export default __webpack_public_path__ + "static/media/piraten-kapern.9c3b5e11.png";